import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@ontruck/orc';

const ContactCard = ({
  t,
  className,
  isFirst,
  contact,
  onClick,
  handleStartOrderWithAddress,
}) => (
  <div className={`${className} ${isFirst ? 'first' : ''}`}>
    <div className="info">
      <p className="companyInfo">
        {contact.company_name} - {contact.label}
      </p>
      <p className="addressInfo">{contact.address_line}</p>
      <p className="contactInfo">
        {`${contact.contact_name || t('card.no_contact')} · ${
          contact.contact_phone || t('card.no_phone')
        }`}
      </p>
    </div>
    <div className="actions">
      <Button text={t('card.edit')} skin="secondary" onClick={onClick} />
      <Button
        text={t('card.new_shipment')}
        skin="secondary"
        onClick={handleStartOrderWithAddress}
      />
    </div>
  </div>
);

ContactCard.propTypes = {
  className: PropTypes.string,
  contact: PropTypes.shape({
    company_name: PropTypes.string,
    label: PropTypes.string,
    address_line: PropTypes.string,
    contact_phone: PropTypes.string,
  }),
  isFirst: PropTypes.bool,
  onClick: PropTypes.func,
  t: PropTypes.func,
  handleStartOrderWithAddress: PropTypes.func,
};

ContactCard.defaultProps = {
  className: '',
  isFirst: false,
  onClick: () => ({}),
  t: (t) => t,
  handleStartOrderWithAddress: () => ({}),
  contact: {
    company_name: '',
    label: '',
    address_line: '',
    contact_phone: '',
  },
};

export default ContactCard;
